import { faSparkles } from '@fortawesome/pro-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { Typography } from '@material-ui/core'
import { makeStyles } from '@material-ui/core/styles'
import { Alert } from '@material-ui/lab'
import theme from 'material/theme'

const useStyles = makeStyles((theme) => ({
  alert: {
    margin: theme.spacing(3, 3, 0, 3),
  },
  secondaryAlert: {
    backgroundColor: theme.palette.secondary.light,
    color: theme.palette.secondary.dark,
    margin: theme.spacing(3, 3, 0, 3),
  },
  link: {
    color: 'inherit',
    textDecoration: 'underline',
  },
}))

const MarketingBanner = ({ hasMessages, route }: { hasMessages: boolean; route: 'one-time' | 'automated' }) => {
  const classes = useStyles()

  if (hasMessages && route === 'one-time') {
    return (
      <Alert
        className={classes.secondaryAlert}
        icon={
          <FontAwesomeIcon
            icon={faSparkles}
            color={theme.palette.secondary.dark}
          />
        }
      >
        <Typography>
          Your institution is on the Starter plan, which doesn't include creating or sending One-Time Messages. The
          messages below are disabled and shown for reference from a previous plan. Check out Scoir's{' '}
          <a
            href="https://www.scoir.com/colleges/pricing"
            target="_blank"
            rel="noopener noreferrer"
            className={classes.link}
          >
            plans and features
          </a>{' '}
          or reach out to your Customer Success Manager to discuss options.
        </Typography>
      </Alert>
    )
  }

  if (route === 'automated') {
    return (
      <Alert
        severity="info"
        className={classes.alert}
      >
        <Typography>
          {hasMessages
            ? `Your institution is on the Starter plan, which includes a set of automated messages managed by Scoir. Any
          messages you see below that aren't marked "Starter" are disabled and shown for reference from a previous plan.
          Reach out to your Customer Success Manager to create or edit messages or explore plan options.`
            : `Your institution is on the Starter plan, which includes a set of automated messages managed by Scoir. 
            Reach out to your Customer Success Manager to create messages or explore Scoir plans.`}
        </Typography>
      </Alert>
    )
  }
  return null
}

export default MarketingBanner
